import React from 'react';

/**
 * VoiceOverlay. Compact status bar during voice mode.
 *
 * Shows only the current state (listening/speaking) and a short preview
 * of the last utterance. The full conversation is already in the chat below,
 * so we keep this minimal to avoid duplication.
 */
export default function VoiceOverlay({ isSpeaking, isListening, hasUserSpoken, onStop }) {
  let statusLabel;
  let statusIcon;
  if (isSpeaking) {
    statusLabel = 'Matcher spreekt...';
    statusIcon = 'record_voice_over';
  } else if (isListening && !hasUserSpoken) {
    statusLabel = 'Microfoon actief, begin met praten';
    statusIcon = 'mic';
  } else if (isListening) {
    statusLabel = 'Luistert naar jou...';
    statusIcon = 'mic';
  } else {
    statusLabel = 'Verbonden';
    statusIcon = 'hearing';
  }

  return (
    <div className="voice-overlay">
      <span className="voice-overlay__pulse" />
      <span className="voice-overlay__status-icon material-icons">{statusIcon}</span>
      <span className="voice-overlay__status-label">{statusLabel}</span>
      <button
        type="button"
        className="voice-overlay__stop"
        onClick={onStop}
        aria-label="Pauzeer spraak"
      >
        <span className="material-icons">pause</span>
        Pauze
      </button>
    </div>
  );
}
